export default function getErrorPayload(error) {
  var _error$response;

  return (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || {
    message: (error === null || error === void 0 ? void 0 : error.message) || "Unexpected error"
  };
}